export const TW_VIDEO_TAG = '#TwVideo:';
export const TW_ACTION_SEPARATOR = ';';
export const TW_ACTION_STOP = 'BYE';
export const TW_ACTION_DECLINE = 'DECLINE';
export const TW_ACTION_CANCEL = 'CANCEL';

export const TW_ERROR_OPEN = 'Open failed';
